<template>
  <div>
    <v-card
      min-width="80vw"
      elevation="1"
      class="rounded-2xl"
      style="background-color: transparent"
    >
      <!-- Header -->
      <v-toolbar flat class="toolbar rounded-t-2xl">
        <span class="white--text text-h4 font-weight-bold">
          {{ item.cod }}
        </span>
      </v-toolbar>

      <v-card-text>
        <!-- Cronograma -->
        <v-divider class="my-6" />
        <h4 class="text-h5 font-weight-medium text-center mb-4">Cronograma</h4>

        <v-row
          v-for="(t, index) in normalizedTimes"
          :key="index"
          dense
          class="mb-2"
        >
          <v-col cols="12" md="2"></v-col>
          <v-col>
            <v-row dense>
              <v-col>
                <custom-select
                  label="Dia da semana"
                  :items="weekDaysItems"
                  :currentValue="t.weekDay"
                  disabled
                />
              </v-col>
              <v-col>
                <custom-select
                  label="Horário de início"
                  :items="startHours"
                  :currentValue="t.start"
                  disabled
                />
              </v-col>
              <v-col>
                <custom-select
                  label="Horário de término"
                  :items="endHours"
                  :currentValue="t.end"
                  disabled
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Professor -->
        <v-divider class="my-6" />
        <v-card elevation="3" class="pa-4 d-flex align-center">
          <v-avatar size="150" class="mr-4" color="primary">
            <v-img
              :src="item.teacher.avatar"
              contain
              v-if="item.teacher.avatar"
            />
            <strong class="white--text" style="font-size: 3rem">S A</strong>
          </v-avatar>
          <div>
            <span class="grey--text">Professor responsável</span>
            <h4 class="gradientTitle mb-1">{{ item.teacher.full_name }}</h4>
            <h4 class="gradientTitle mb-1">{{ item.teacher.email }}</h4>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ClassView",
  props: {
    item: {
      type: Object,
    },
  },
  async mounted() {
    await this.normalizeTimes();
  },

  data: () => {
    return {
      form: {},
      classTime: null,
      normalizedTimes: [],
      englishLevels: [
        {
          text: "Beginner 1",
          value: 0,
        },
        {
          text: "Beginner 2",
          value: 1,
        },
        {
          text: "Essential 1",
          value: 2,
        },
        {
          text: "Essential 2",
          value: 3,
        },
        {
          text: "Pre Intermediate 1",
          value: 4,
        },
        {
          text: "Pre Intermediate 2",
          value: 5,
        },
        {
          text: "Intermediate 1",
          value: 6,
        },
        {
          text: "Intermediate 2",
          value: 7,
        },
        {
          text: "Upper 1",
          value: 8,
        },
        {
          text: "Upper 2",
          value: 9,
        },
        {
          text: "Advanced 1",
          value: 10,
        },
        {
          text: "Advanced 2",
          value: 11,
        },
      ],
      typeOptions: [
        { text: "Individual", value: 1 },
        { text: "Dupla", value: 2 },
        { text: "Trio", value: 3 },
        { text: "Quarteto", value: 4 },
      ],
      weekDaysItems: [
        {
          text: "Domingo",
          value: 0,
        },
        {
          text: "Segunda-feira",
          value: 1,
        },
        {
          text: "Terça-feira",
          value: 2,
        },
        {
          text: "Quarta-feira",
          value: 3,
        },
        {
          text: "Quinta-feira",
          value: 4,
        },
        {
          text: "Sexta-feira",
          value: 5,
        },
        {
          text: "Sábado",
          value: 6,
        },
      ],
      frequencies: [
        { text: "Todos os dias", value: 0 },
        { text: "Uma vez na semana", value: 1 },
        { text: "Duas vezes na semana", value: 2 },
        { text: "Três ou mais", value: 3 },
        { text: "A cada 15 dias", value: 4 },
      ],
      times: [
        {
          text: "60 minutos",
          value: 1,
        },
        {
          text: "90 minutos",
          value: 2,
        },
      ],
      startHours: [],
      endHours: [],
      selected: null,
    };
  },
  methods: {
    displayFormat(format) {
      switch (format) {
        case 1:
          return "Individual";
        case 2:
          return "Dupla";
        case 3:
          return "Trio";
        case 4:
          return "Quarteto";
      }
    },
    displayTime(time) {
      return time === 1 ? "60 minutos" : "90 minutos";
    },
    displayFrequency(frequency) {
      return `${frequency}x semana`;
    },
    displayLevel(level) {
      return this.englishLevels[level].text;
    },
    displayStatus(format) {
      switch (format) {
        case 0:
          return "Aguardando";
        case 1:
          return "Ativo";
        case 2:
          return "Inativo";
        case 3:
          return "Rejeitado";
      }
    },
    setCurrentPlan(plan) {
      if (plan) {
        this.selectedPlan = plan;
        this.currentPlan = plan.value;
      } else {
        return {};
      }
    },
    normalizeTimes() {
      for (let index = 0; index < this.item.weekDays.length; index++) {
        const element = this.item.weekDays[index];
        this.normalizedTimes.push({
          weekDay: +element,
          start: this.item.hours[index].split("-")[0].trim(),
          end: this.item.hours[index].split("-")[1].trim(),
        });
        this.startHours.push(this.item.hours[index].split("-")[0].trim());
        this.endHours.push(this.item.hours[index].split("-")[1].trim());
      }
      const startTime = this.startHours[0];
      const endTime = this.endHours[0];

      const [startHours, startMinutes] = startTime.split(":").map(Number);
      const [endHours, endMinutes] = endTime.split(":").map(Number);

      const startTotalMinutes = startHours * 60 + startMinutes;
      const endTotalMinutes = endHours * 60 + endMinutes;

      const differenceInMinutes = endTotalMinutes - startTotalMinutes;

      this.classTime = +differenceInMinutes > 50 ? 2 : 1;
    },
  },
};
</script>
<style scoped lang="css">
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}

.toolbar {
  background-image: url("@/assets/images/unsplash_aluno.webp");
  background-size: cover;
  background-repeat: no-repeat;
}

.gradientTitle {
  background: linear-gradient(to right, #e8276f, #9923cd);

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  animation: moveGradient 3s linear infinite;
}

.glowingText {
  animation: glowText 0.8 ease-in-out infinite alternate;
}

@keyframes moveGradient {
  0% {
    background-position: 50% 0;
  }

  50% {
    background-position: 0 0;
  }

  100% {
    background-position: 100% 0;
  }
}
</style>
